export default "__VITE_ASSET__r5dvf41B__"